import { ComponentView, ObservableArray } from "binder";
import { getAsBoolean } from "../../../utilities";
import { EnumFilterViewModel, enumValue } from "./enumFilter-viewModel"

export class EnumFilterView extends ComponentView<EnumFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-3FBDC7DC-91A3-44A5-B889-0D265670A8B8"
    }
    loadHtml(): string {
        let element = require('./enumFilter.html').default;
        let style = require('./enumFilter.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isActive(v: boolean) { this._isActive =getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set enumValues(v: ObservableArray<enumValue>) { this._enumValues = v; } public get enumValues(): ObservableArray<enumValue> { return this._enumValues;} private _enumValues: ObservableArray<enumValue>;

    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }
    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }
}
